import { toast } from "react-toastify";
import { fetchCreateUserRoleSuccess,fetchCreateUserRoleFailure } from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { ROLE } from "../../constants/constants";

export const createUserRole = (payload, setLoading,navigate) => async (dispatch) => {
  try {
    setLoading(true);
    const response = await determineBaseUrlAndPerformApiCall(`${ROLE}`, 'POST', payload);
    if (!response.error) {
      dispatch(fetchCreateUserRoleSuccess(response));
      navigate("/userroles", { state: { successMessage: "User role created successfully!" } });
    } else {
      dispatch(fetchCreateUserRoleFailure(response.error.message));
      toast.error(response.error.message);
    }
  } catch (error) {
    console.error("Error in creating user role:", error);
    dispatch(fetchCreateUserRoleFailure(error.message));
    toast.error(error.message);
  } finally {
    setLoading(false);
  }
};
